// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__N10Uf"};